import logoPanda from '@app/assets/logo.svg';
import { cn } from '@app/lib/utils';

import { Link as RouterLink } from 'react-router-dom';

export default function Logo({ compactOnMobile = false }: { compactOnMobile?: boolean }) {
  return (
    <RouterLink
      to="/"
      aria-label="Promptfoo home"
      data-testid="home-link"
      className={cn(
        'inline-flex items-center py-2 no-underline [perspective:2000px] [transform-style:preserve-3d]',
        compactOnMobile ? 'px-2 sm:px-4' : 'px-4',
      )}
    >
      <img
        src={logoPanda}
        alt="Promptfoo Logo"
        className="h-auto w-[25px] transition-transform duration-300 hover:rotate-12 hover:scale-110"
      />
      <span
        className={cn(
          'ml-2 font-semibold text-base text-foreground tracking-[0.02em] transition-colors hover:text-primary',
          compactOnMobile && 'hidden sm:inline',
        )}
      >
        promptfoo
      </span>
    </RouterLink>
  );
}
